module.exports = __webpack_public_path__ + "stylesheets/info-app-sumo_f63181af17b5419fe8f67705ee57ec13.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/settings/info-app-sumo.less
// module id = yQlI
// module chunks = 154